export const PER_ROW_MORE = 'MORE';
export const PER_ROW_LESS = 'LESS';
export const PER_ROW_SESSION_KEY = 'pr_value';
